export default "__VITE_ASSET__c24f535d__"